import type { InvisData } from './types';

/** All ten, as the board prints them — 10 emails over 58 days, already written. */
export const INVIS: InvisData = {
  purchased: true,
  system: 'Invisalign',
  consultReason: 'Invisalign Consult',
  invisLineNumber: '(210) 555‑0164',
  signals: [
    {
      id: 'chart-interest',
      label: 'Interest noted in the chart',
      desc: 'A provider or a hygienist wrote it down after a visit.',
      on: true,
    },
    {
      id: 'unused-ortho',
      label: 'An unused orthodontic benefit',
      desc: 'Money already paid for that nobody has spent.',
      on: true,
    },
    {
      id: 'family',
      label: 'A family member already in treatment',
      desc: 'The single strongest predictor in the list.',
      on: true,
    },
  ],
  reAskMonths: 6,
  smileProfileStops: 2,
  smileProfileTotal: 8,
  emails: [
    {
      day: 0,
      subject: 'A straighter smile, without anyone noticing',
      what: 'Opens on the thing most adults actually care about — nobody seeing it.',
      enabled: true,
    },
    {
      day: 2,
      subject: 'How clear aligners really work',
      what: 'Mechanics, plainly. No brand claims, no numbers yet.',
      enabled: true,
    },
    {
      day: 5,
      subject: 'What it costs, and what your plan covers',
      what: 'The first money email. Degrades to a range without benefit data.',
      enabled: true,
      degradesToRange: true,
    },
    {
      day: 9,
      subject: 'How long it usually takes',
      what: 'Sets a realistic expectation before anyone asks.',
      enabled: true,
    },
    {
      day: 14,
      subject: 'Eating, speaking, and the bit people worry about',
      what: 'The objection nobody says out loud.',
      enabled: true,
    },
    {
      day: 21,
      subject: 'What the first visit is like',
      what: 'Removes the unknown from the only thing being asked for.',
      enabled: true,
    },
    {
      day: 30,
      subject: 'The question we are asked most',
      what: 'One answer, at the point interest usually cools.',
      enabled: true,
    },
    {
      day: 40,
      subject: 'Your benefit resets on 1 January',
      what: 'Deadline framing. Sent only inside the year-end window.',
      enabled: true,
      yearEndOnly: true,
    },
    {
      day: 49,
      subject: 'Still thinking it over?',
      what: 'One direct ask, near the end.',
      enabled: true,
    },
    {
      day: 58,
      subject: 'We will leave it there',
      what: 'Says it is stopping. Nobody is left wondering whether more is coming.',
      enabled: true,
    },
  ],
  lockedRules: [
    {
      label: 'Email only',
      reason:
        'An aligner decision takes weeks and involves money and a mirror. A text is the wrong length for it and a call is the wrong pressure.',
    },
    {
      label: 'The conversation window closes after 24 hours',
      reason:
        'A reply the same day is answered. A reply three weeks later goes to a person — an email thread ELVA keeps answering forever stops being a campaign and becomes an unwatched clinical conversation.',
    },
    {
      label: 'No images in V1',
      reason:
        'Before-and-after pictures are the obvious thing to want here, and they are a regulated claim in most places — and this product has nowhere yet to record that a patient agreed to theirs being used.',
    },
  ],
  patientsMidSequence: 23,
};
